module.exports = __webpack_public_path__ + "img/原油管输在线计量系统V1.0.d2d15abb.jpg";